export default class StringUtils {
    //to covert into camelcase by using same value from language file.
    public convertToCamelCase = (str: unknown): string => {
        let response = '';
        try {
            if (typeof str !== 'string') {
                console.log('convertToCamelCase: input is not a string', str);
            } else {
                const words = str.trim().toLowerCase().split(/\s+/);

                if (!words.length) return response;

                response =
                    words[0] +
                    words
                        .slice(1)
                        .map(
                            (word) =>
                                word.charAt(0).toUpperCase() + word.slice(1),
                        )
                        .join('');
            }
        } catch (e) {
            console.error('convertToCamelCase failed:', e);
        }

        return response;
    };
}
